import buffer from 'buffer'
export const columns = (vm) =>{
    return [
        // {
        //     label:'',
        //     width:50,
            // headerAlign:"center",
            // align:"center",
        //     type:'selection',
        // },
        {
            label:'消息ID',
            prop:'uuid',
            align:'left',
            headerAlign:'left',
            width:160,
        },
        {
            label:'序列号/IMEI',
            prop:'deviceId',
            align:'left',
            headerAlign:'left',
            width:160,
            tooltip:true
        },
        {
            label:'hexData',
            prop:'hexData',
            align:'left',
            headerAlign:'center',
            width:300,
           
        },
        {
            label:'字符串',
            align:'left',
            headerAlign:'center',
            width:300,
            tooltip:true,
            render:(h,params)=>{
                let str = hexToStr(params.row.hexData,'utf-8')
                return h('span',{},str)
            }
        },
        {
            label:'设备IP/端口',
            minWidth:180,
            align:'center',
            headerAlign:'center',
            render: (h, params) => {
               return h('span',{},params.row.deviceHostName+":"+params.row.devicePortName)
            }

        },
        {
            label:'网关IP/端口',
            align:'center',
            minWidth:180,
            headerAlign:'center',
            tooltip:true,
            render: (h, params) => {
               return h('div',{},params.row.gatewayHostName+":"+params.row.gatewayPort)
            }

        },
        {
            label:'消息方向',
            minWidth:100,
            align:"center",
            headerAlign:"center",
            render: (h, params) => {
                return h('div',{},params.row.orderDirect == 0?'发送':'接收')
            }
        },
        {
            label:'接收/处理时间',
            prop:'receiveTime',
            align:'left',
            headerAlign:'left',
            width:140,
            render: (h,params)=>{
                return h('div',{},params.row.receiveTime+"  "+params.row.processTime)
            }
        },
        {
            label:'服务',
            prop:'serviceName',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'备注',
            prop:'remark',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'操作',
            minWidth:100,
            // fixed: 'right',
            align:"center",
            headerAlign:"center",
            render: (h, params) => {
                const look = (h) => {
                    return h('span', {
                          props: {
                              type:'primary',
                              size:"mini"
                          },
                          style: {
                            color:"#458EFF"
                          },
                          on: {
							click: () => {
								vm.lookBtn(params.row);
							}
						}
                      }, '查看');
                };
                
                return h('div',{},[look(h)])
            }
        }
    ]
}

function hexToStr(hex,encoding) {
    var trimedStr = hex.trim();
    var rawStr = trimedStr.substr(0, 2).toLowerCase() === "0x" ? trimedStr.substr(2) : trimedStr;
    var len = rawStr.length;
    if (len % 2 !== 0) {
      alert("Illegal Format ASCII Code!");
      return "";
    }
    var curCharCode;
    var resultStr = [];
    for (var i = 0; i < len; i = i + 2) {
      curCharCode = parseInt(rawStr.substr(i, 2), 16);
      resultStr.push(curCharCode);
    }
    // encoding为空时默认为utf-8
    var bytesView = new Uint8Array(resultStr);
    var str = new TextDecoder(encoding).decode(bytesView);
    return str;
  }